import { makeStyles } from '@material-ui/core'

import polygonBlue from 'images/Polygon_2.svg'
import polygonGreen from 'images/polygon_dark_green.svg'

const useStyles = makeStyles((theme) => ({
  questionnaireList: {
    display: 'flex',
    flexDirection: 'column',
    gridGap: theme.spacing(1),
    padding: theme.spacing(0, 2, 2),
    overflowY: 'auto',
    maxHeight: 310,
  },
  questionnaireItem: {
    display: 'flex',
    alignItems: 'center',
    gridGap: theme.spacing(2),
    padding: theme.spacing(1.5, 2),
    borderRadius: 8,
    backgroundColor: theme.palette.background.default,
  },
  questionnaireItemComplete: {
    border: '1px solid #80B92B',
  },
  questionnaireItemIncomplete: {
    border: '1px solid #B8DAF7',
  },
  hexBadgeTextDark: {
    color: theme.palette.common.black,
    fontWeight: 700,
    fontSize: 11,
    lineHeight: 1,
    textAlign: 'center',
  },
  hexBadgeTextLight: {
    color: theme.palette.common.white,
    fontWeight: 700,
    fontSize: 11,
    lineHeight: 1,
    textAlign: 'center',
  },
  hexPolygon: {
    backgroundSize: '85%',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundColor: 'transparent',
    overflow: 'hidden',
  },
  hexPolygonBlue: {
    backgroundImage: `url(${polygonBlue})`,
  },
  hexPolygonGreen: {
    backgroundImage: `url(${polygonGreen})`,
  },
}))

export default useStyles
